<template>
  <div class="dialog-component" v-if="dialogFormVisible">
    <el-dialog
      :title="dialogObj.titleName"
      :before-close="handleClose"
      :visible.sync="dialogFormVisible"
      width="766px"
    >
      <el-radio-group
        :value="editObj.active"
        v-model="currentItem"
        size="small"
      >
        <el-radio-button label="1" >饲料</el-radio-button>
        <el-radio-button label="2" >渔药</el-radio-button>
        <el-radio-button label="3" >疫苗</el-radio-button>
        <el-radio-button label="4" >渔肥</el-radio-button>
      </el-radio-group>

      <div v-if="currentItem == 1">
        <feed-component @update="update"></feed-component>
      </div>
      <div v-if="currentItem == 2">
        <medicine-component @update="update"></medicine-component>
      </div>
      <div v-if="currentItem == 3">
        <vaccine-component @update="update"></vaccine-component>
      </div>
      <div v-if="currentItem == 4">
        <guano-component @update="update"></guano-component>
      </div>

      <!-- <el-tabs :value="editObj.active" @tab-click="handleClick">
        <el-tab-pane label="饲料" name="first">
          <feed-component @update="update"></feed-component>
        </el-tab-pane>
        <el-tab-pane label="渔药" name="second">
          <medicine-component @update="update"></medicine-component>
        </el-tab-pane>
        <el-tab-pane label="疫苗" name="third">
          <vaccine-component @update="update"></vaccine-component>
        </el-tab-pane>
      </!-->
    </el-dialog>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { mapActions, mapState, mapMutations } from "vuex";
import { modules } from "../../../store";
import FeedComponent from "./tabComponent/FeedComponent.vue";
import MedicineComponent from "./tabComponent/MedicineComponent.vue";
import VaccineComponent from "./tabComponent/VaccineComponent.vue";
import GuanoComponent from "./tabComponent/GuanoComponent.vue";
export default Vue.extend({
  name: "DialogComponent",
  components: {
    FeedComponent,
    MedicineComponent,
    VaccineComponent,
    GuanoComponent,
  },
  props: {
    dialogObj: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      currentItem: 1,
      activeName: "first",
      formLabelWidth: "80px",
      form: {
        name: "string",
        fishStockAbstract: 0,
        unit: "string",
        scaling: 0,
        type: "string",
        spec: "string",
      },
      rules: {
        name: [
          {
            required: true,
            message: "请先选择养殖品种",
            trigger: "blur",
          },
        ],
        unit: [
          {
            required: true,
            message: "请先选择计量单位",
            trigger: "blur",
          },
        ],
      },
    };
  },
  async mounted() {
    if (this.editObj.category == "饲料") {
      this.activeName = "second";
    }
    // let kk = await this.getMeasurementUnit(1);
  },
  computed: {
    ...mapState(modules.materialSetting, [
      "dialogFormVisible",
      "dialogFormVisible",
      "editObj",
    ]),
  },
  methods: {
    ...mapActions(modules.dataDict, ["getMeasurementUnit"]), //计量单位
    ...mapActions(modules.materialSetting, [
      "getMaterialSettingData", //查询
      "delMaterialSettingList", //删除
      "addMaterialSetting", //添加
    ]),
    ...mapMutations(modules.materialSetting, [
      "setDialogFormVisible",
      "setDialogObj",
    ]),
    handleClose() {
      this.setDialogFormVisible(false);
    },
    changeItem(type) {
      this.currentItem = type;
    },
    handleClick(tab, event) {
      // this.setDialogObj({
      //   id: "",
      //   category: "",
      //   active: "first",
      //   isShow: false
      // });
    },
    update() {
      this.$emit("updatelist");
    },
    save(name) {},
    cancel() {
      console.log("quxiao");
    },
  },
  watch:{
    'editObj.active': {
      handler(newVal,oldVal){
        switch (newVal) {
          case 'first':
            this.currentItem = '1'
            break;
          case 'second':
            this.currentItem = "2"
            break;
          case 'third':
            this.currentItem = '3'
            break;
          case 'fourth':
            this.currentItem = '4'
            break;
          default:
            break;
        }
        console.log(this.currentItem, newVal ,233);
        
      },
      deep: true
    }
  }
});
</script>

<style lang="stylus">
.dialog-component
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
      -webkit-appearance: none !important;
      margin: 0;
  }
  .scale
    display flex;
    width 500px;
    text-align:center;
    >*
      flex 1;
    .el-input
      width:initial;
    .el-input .el-input__inner
      width:220px !important;
    .scal .el-input__inner
      width:100px !important;

  .el-dialog
    .el-dialog__header
      padding: 12px 20px 12px;
      background:linear-gradient(270deg,rgba(51,137,255,1),rgba(31,156,244,1),rgba(49,170,255,1));
      .el-dialog__title
        color: #fff;
    .el-icon-close:before
      content: "\E60F";
      color:#fff;
    .el-dialog__headerbtn
      top:16px;
    .el-dialog__body {
      padding:20px 40px;
      color: #606266;
      font-size: 14px;
    }
    .el-form-item
      align-items  center;
      .el-form-item__label
        margin-left:30px;
        text-align:right;
    .el-form-item__content
      font-size: 14px;
    .el-form-item__error {
      color: #f56c6c;
      font-size: 12px;
      line-height: 1;
      padding-top: 4px;
      position: absolute;
      top: 100%;
      left: 38px;
    }
    .el-dialog__footer
      text-align left
      position relative
      bottom:12px;
      padding:0px 106px 0px;
    .el-button--primary
      margin-left:20px;
      background: #3389ff;
    .el-button--default
      margin-left:40px;
    .el-button
      width 100px
      height 40px
    [class*=el-col-]
      line-height
    .ruleForm
      margin-left 0px
    .el-input__inner
      margin-left:10px;
    .el-select .el-input__inner
      width:500px;
     .el-radio-button:nth-child(1)
      .el-input .el-input__inner
        width:500px;
      .el-input
        width:500px;
     .el-radio-button:nth-child(2)
      .el-input
        width:500px;
      .el-input .el-input__inner
        width:500px;
     .el-radio-button:nth-child(3)
      .el-input .el-input__inner
        width:500px;
      .el-input
        width:500px;
    .dialog-footer
      margin:35px 90px;
    .el-radio-group{
      height: 38px;
      border:1px solid #e0e0e0;
      margin-bottom:50px;
      margin-left:20px;
      .el-radio-button,.el-radio-button__orig-radio{
        text-align:center;
        width:159px;
        padding:0;
        font-size 16px;
        color:#8b93a6;
      }
      .el-radio-button__inner{
        border:none;
        font-size 16px;
        color:#8b93a6;
        background none;
        transition:none;
      }
      .el-radio-button.is-active {
        color: #fff;

        background: #209cf5;
        height 38px;
        line-height 38px;
      }
      .el-radio-button:nth-child(1){
        border-right:1px solid #e1e1e1!important;
      }
      .el-radio-button:nth-child(2){
        border-right:1px solid #e1e1e1!important;
      }
      .el-radio-button:nth-child(3){
        border-right:1px solid #e1e1e1!important;
      }
      .el-radio-button__orig-radio:checked+.el-radio-button__inner {
        color: #FFF;
        background-color: #209cf5;
        width:159px;
         height 38px;
        line-height 38px;
        padding:0;
        font-size 16px;
      }


    }
</style>
